const state = function () {
    return {
        isResponse: Number,
        isMsg: String,
        modalUsage: false
    };
};

export default state;
